import React from 'react'
import 'react-vertical-timeline-component/style.min.css';
import CTA from '../components/CTA';

const About = () => {
  return (
    <section className='max-container'>
      <h1 className='head-text'>
        Hello, I'm <span className='blue-gradient-text font-semibold drop-shadow'>Sairam</span>

      </h1>
      <div className='mt-5 flex flex-col gap-3 text-slate-500'>
        <p className='font-semibold'>Passionate coder, creative thinker, and tech enthusiast. With a knack for problem-solving, I navigate the digital realm with curiosity and innovation. From competitive coding to web development, my journey reflects a commitment to continuous learning and a drive to make an impact in the world of technology.</p>
        <br/>
        <p className='font-semibold'>I am a 4th year student pursuing B.Tech in Computer Science at Vellore Institute of Technology, Chennai.</p>
        <br/>
        <p className='font-semibold'>I had no prior experience in coding while starting college, I was initially intimidated by how much everyone else knew about coding. But with hardwork and support from my friends, I got the hang of programming.</p>
        <br/>
        <p className='font-semibold'>And then I found my niche in Web Development and Machine Learning and made projects in these domains. Please feel free to check out my projects in the Projects section and provide valuable criticism... </p>
        <br/>
      </div>

      
      <hr className='border-slate-200'/>
      <CTA/>
    </section>
  )
}

export default About